





















import { Component, Vue } from 'vue-property-decorator';
import { Button } from './components';

@Component({
  components: {
    Button,
  },
})
export default class Cancellation extends Vue {
  flag: boolean = true;

  toggle() {
    this.flag = !this.flag;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/purchases/components/cancellation/Cancellation.vue